module.exports = __webpack_public_path__ + "static/media/brainflix-combined.07a8fdb7.png";